import React from 'react'

const HeroSection = () => {
    return (
        <section id="portfolio" className="py-16 px-4 md:py-24" style={{ background: 'linear-gradient(297.01deg, #2196F3 -116.99%, #000000 100%)' }}>
            <div className="max-w-5xl mx-auto">
                {/* Portfolio Heading */}
                <div className='flex flex-col w-full h-full md:flex-row justify-between items-center mx-auto gap-10 pt-10 py-8 md:py-0 md:pt-16'>
                    <div className='order-1 md:order-2 w-64 md:w-[27rem]'>
                        <img src="/assets/portfolio-bg.png" alt="Portfolio" className='w-full h-auto' />
                    </div>

                    <div className="text-center md:text-start mb-10 hidden md:block order-2 md:order-1">
                        <h2 className="text-3xl md:text-6xl font-bold mb-4 text-white">Apps that climb<br />the summit</h2>
                        <p className="text-gray-300 text-sm md:text-2xl max-w-2xl mx-auto">
                            Real results real users, built for scale,<br />performance with vision.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default HeroSection